import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NavigationButton from "../../classResults/components/lessonNavigation/NavigationButton";
import studentTabWeekly from "../../../assets/images/student_tab_weekly.png";
import studentTabMonthly from "../../../assets/images/student_tab_monthly.png";

const StudentSelector = ({ students, selectedStudentId, onStudentChange }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // 현재 페이지가 월간 페이지인지 확인
  const isMonthlyPage = location.pathname.includes('studentMonthlyResults');
  
  // students가 변경될 때 선택된 학생 ID 확인 및 업데이트
  useEffect(() => {
    if (students && students.length > 0) {
      // 선택된 학생 ID가 없거나 students 배열에 없는 경우 첫 번째 학생 선택
      const studentExists = students.some(s => String(s.studentId) === String(selectedStudentId));
      if (!studentExists) {
        onStudentChange(students[0].studentId);
      }
    }
  }, [students, selectedStudentId, onStudentChange]);

  // 이전 학생 버튼 비활성화 여부 확인
  const isPrevButtonDisabled = () => {
    if (!students || students.length === 0) return true;
    const currentIndex = students.findIndex(s => String(s.studentId) === String(selectedStudentId));
    return currentIndex <= 0;
  };

  // 다음 학생 버튼 비활성화 여부 확인
  const isNextButtonDisabled = () => {
    if (!students || students.length === 0) return true;
    const currentIndex = students.findIndex(s => String(s.studentId) === String(selectedStudentId));
    return currentIndex >= students.length - 1 || currentIndex === -1;
  };

  // 이전 학생으로 이동
  const goToPreviousStudent = () => {
    if (isPrevButtonDisabled()) return;
    
    const currentIndex = students.findIndex(s => String(s.studentId) === String(selectedStudentId));
    if (currentIndex > 0) {
      onStudentChange(students[currentIndex - 1].studentId);
    }
  };

  // 다음 학생으로 이동
  const goToNextStudent = () => {
    if (isNextButtonDisabled()) return;
    
    const currentIndex = students.findIndex(s => String(s.studentId) === String(selectedStudentId));
    if (currentIndex < students.length - 1) {
      onStudentChange(students[currentIndex + 1].studentId);
    }
  };

  // 페이지 전환 (주간 ↔ 월간)
  const togglePage = () => {
    if (isMonthlyPage) {
      // 월간 페이지에서 주간 페이지로
      navigate(`/page/studentWeeklyResults?studentId=${selectedStudentId}`);
    } else {
      // 주간 페이지에서 월간 페이지로
      navigate(`/page/studentMonthlyResults?studentId=${selectedStudentId}`);
    }
  };

  return (
      <div className="flex justify-center items-center">
        <div className="pb-8 pt-[60px] flex flex-row justify-between items-center border-b-[1px] border-[#B0B2B8] w-[1044px] ">
          <div className="flex items-center justify-center">
            <NavigationButton
                onClick={goToPreviousStudent}
                disabled={isPrevButtonDisabled()}
                className={`flex items-center justify-center w-10 h-10 rounded-full 
                ${isPrevButtonDisabled()
                    ? 'bg-gray-100 cursor-not-allowed'
                    : 'bg-blue-100 hover:bg-blue-200'
                }`}
                direction="prev"
            >
            </NavigationButton>

            <div className="relative">
              <select
                  value={selectedStudentId || ''}
                  onChange={(e) => onStudentChange(e.target.value)}
                  className="appearance-none bg-white text-lg font-medium py-2 px-4 pr-8 border border-gray-300 hover:border-gray-400 rounded-lg shadow leading-tight focus:outline-none focus:border-blue-500"
              >
                <option value="">학생 선택</option>
                {students?.map((student) => (
                    <option key={student.studentId} value={student.studentId}>
                      {student.name}
                    </option>
                ))}
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                  <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/>
                </svg>
              </div>
            </div>

            <NavigationButton
                onClick={goToNextStudent}
                className={`flex items-center justify-center w-10 h-10 rounded-full 
                ${isNextButtonDisabled()
                    ? 'bg-gray-100 cursor-not-allowed'
                    : 'bg-blue-100 hover:bg-blue-200'
                }`}
                disabled={isNextButtonDisabled()}
                direction="next"
            >
            </NavigationButton>
            <div className="text-[#50555F] text-[38px] font-[700]">
              {isMonthlyPage ? "학생의 월간 보고서": "학생의 주간 학습 결과" }
            </div>
          </div>
          <div
            className="flex items-center"
          >
            <button
              onClick={togglePage}
              className="hover:opacity-80 transition-opacity duration-200"
            >
              <img 
                src={isMonthlyPage ? studentTabMonthly : studentTabWeekly}
                alt={isMonthlyPage ? "주간 결과 보기" : "월간 결과 보기"} 
                className="w-auto h-auto"
              />
            </button>
          </div>
        </div>
      </div>
  );
};

export default StudentSelector; 